import React from 'react';
import './index.css';

export type InformationButtonProps = {
  onClick: React.MouseEventHandler;
};

const InformationButton = ({ onClick }: InformationButtonProps) =>
  onClick ? (
    <small>
      <span>
        <button
          type="button"
          className="btn btn-primary btn-circle"
          onClick={onClick}>
          <span className="oi oi-question-mark" />
        </button>
      </span>
    </small>
  ) : null;

export default InformationButton;
